import React from 'react'
import { Markup } from 'src/components/Reusable/Text/Markup'
import { EvidenceShowTabBody } from 'src/pages/Evidence/evidence.styles'

export const EvidenceSourceBody = ({
  sourcesMarkdown,
}: {
  sourcesMarkdown: string
}): JSX.Element => (
  <EvidenceShowTabBody>
    <Markup markdown={sourcesMarkdown} />
  </EvidenceShowTabBody>
)
